// extracted by mini-css-extract-plugin
export default {"container":"VisitedExpositionsItem_container__U-d13","name":"VisitedExpositionsItem_name__pGKQC","type":"VisitedExpositionsItem_type__pzbb+"};